import LoyaltySpec from "../components/loyaltyManagement/loyaltySpec/LoyaltySpec";
import ResponsiveContentWrapper from "../components/layout/ResponsiveContentWrapper";
import { useEffect, useState } from "react";
import ScreenLoader from "../components/Common/ScreenLoader/ScreenLoader";

const LoyaltySpecPage = () => {

  /**
   * This is a temporary fix for styling issues caused by conflicts between Material Design v4 and v6. 
   * It will be removed once the migration is fully completed.
   * Line no. 3, 4, 14-25, 27-29 will be removed
   */
  const [isReloading, setIsReloading] = useState(false);
  useEffect(() => {
    const reloadKey = "loyalty_spec_reloaded";
    const hasReloaded = sessionStorage.getItem(reloadKey);
    if (!hasReloaded) {
      sessionStorage.setItem(reloadKey, "true");
      setIsReloading(true);
      window.location.reload();
    }
    return () => {
      sessionStorage.removeItem(reloadKey);
    };
  }, []);

  if (isReloading) {
    return <ScreenLoader message={"Fetching data..."} />;
  }

  return (
    <ResponsiveContentWrapper>
      <LoyaltySpec />
    </ResponsiveContentWrapper>
  );
};

export default LoyaltySpecPage;
